<template>
    <div class="col-md-12">
        <div class="row justify-content-md-center fondo-color" v-if="tituloRecurso!==''">
            <div class=" col-md-8" style="margin-top: 1%">
                <div class="col-md-12 card estilo">
                    <div style="margin-top: 3%">
                        <div id="cabecera" style="text-align: center; margin-bottom: 45px;">
                            <img class="imagen responsive"
                                src="https://www.numier.com/wp-content/uploads/2015/07/Numier-logo-HORIZONTAL.png"/>

                            <div style="margin-top: 3%" class="col-md-12">
                                <h2 class="fuente">{{tituloRecurso}}</h2>
                            </div>
                        </div>
                        <div class="col-md-12"
                             v-html="textoRecurso">
                        </div>
                        <div class="col-md-12" v-bind:class="getClass()"
                             v-html="detalleRecurso"> 
                        </div>
                       <!--<div class="col-md-12 cont-movil">
                            <iframe src="https://www.numier.com/recursos/recurso-12.pdf#toolbar=0&navpanes=0&scrollbar=0"
                                    width="100%" height="100%" type="application/pdf"/>
                        </div>
                        <br/>-->
                        <hr>
                        <div style="margin-bottom:10px" class="col-md-12" align="center" v-if="!valorado">
                            <strong style="font-size: 20px">{{$t('teHaParecidoUtilEsteArticulo')}}</strong><br>
                            <i style="font-size: 45px; color:#ffc107" @click="saveValoracion(1)" v-if="estrella>0"
                               class="fas fa-star"></i>
                            <i style="font-size: 45px; color:#454545" @click="saveValoracion(1)" v-else
                               class="far fa-star"></i>
                            <i style="font-size: 45px; color:#ffc107" @click="saveValoracion(2)" v-if="estrella>1"
                               class="fas fa-star"></i>
                            <i style="font-size: 45px; color:#454545" @click="saveValoracion(2)" v-else
                               class="far fa-star"></i>
                            <i style="font-size: 45px; color:#ffc107" @click="saveValoracion(3)" v-if="estrella>2"
                               class="fas fa-star"></i>
                            <i style="font-size: 45px; color:#454545" @click="saveValoracion(3)" v-else
                               class="far fa-star"></i>
                            <i style="font-size: 45px; color:#ffc107" @click="saveValoracion(4)" v-if="estrella>3"
                               class="fas fa-star"></i>
                            <i style="font-size: 45px; color:#454545" @click="saveValoracion(4)" v-else
                               class="far fa-star"></i>
                            <i style="font-size: 45px; color:#ffc107" @click="saveValoracion(5)" v-if="estrella>4"
                               class="fas fa-star"></i>
                            <i style="font-size: 45px; color:#454545" @click="saveValoracion(5)" v-else
                               class="far fa-star"></i>
                        </div>
                        <div style="margin-bottom:10px" v-else class="col-md-11">
                            <strong style="font-size: 20px">{{$t('graciasPorTuOpinion')}}</strong><br>
                        </div>
                    </div>
                </div>
            </div>
            </div>

        </div>

    </div>

</template>
<script>
    import ContentFooter from '../../Dashboard/Layout/ContentFooter.vue'
    import {VueEditor} from 'vue2-editor';
    import swal from 'sweetalert2';
    import {DatePicker, Option, Select, Switch} from 'element-ui';

    export default {
        name: "RecursosClientes",
        components: {
            VueEditor,
            ContentFooter,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Option.name]: Option,
            [Switch.name]: Switch

        },
        created() {

            if (this.idRecurso) {
                this.getRecursoById();
            }

        },
        data() {
            return {

                //ATRIBUTOS CATEGORIAS
                idCategoria: 0,
                listCategoriasRecursos: [],

                estrella: 0,

                idRecurso: this.$route.params.idRecurso,

                tituloRecurso: "",
                detalleRecurso: "",
                textoRecurso: "",
                date: 0,


                valorado: false,


            }
        },
        methods: {

            saveValoracion(valoracion) {

                this.estrella = valoracion;


                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    valoracion: this.estrella,
                    idRecurso: this.idRecurso,
                };

                let vm = this;

                this.axios.post(this.$store.getters.apiUrl + 'recursos/saveValoracion', params, config)
                    .then(function (response) {

                            if (response.data.response) {

                                vm.valorado = true;


                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }
                    ).catch(function (error) {
                    console.log(error);
                });

            },

            getClass() {
                if(this.detalleRecurso) {
                    return 'cont-movil';
                }
            },

            getRecursoById() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idRecurso: this.idRecurso,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                }

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "recursos/getRecursoById", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.tituloRecurso = response.data.result.titulo;
                            vm.detalleRecurso = response.data.result.detalle;
                            vm.textoRecurso = response.data.result.textoPlano;
                            vm.idCategoria = parseInt(response.data.result.idCategory);
                            vm.date = response.data.result.date


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            // reajuste() {
            //
            //     //WIDTH
            //
            //     this.$refs.miIframe.width = '100%';
            //     this.$refs.miIframe.height = '3435px';
            //
            //
            //     // console.log(this.$refs.miIframe.scrollHeight);
            //
            //     console.log(this.$refs.contenedor.scrollHeaight);
            //
            //     //this.$refs.miIframe.height=this.$refs.miIframe.scrollHeight+this.$refs.miIframe.scrollHeight+this.$refs.miIframe.scrollHeight
            //
            //     //this.$refs.miIframe.height=this.$el.offsetHeight+this.$el.scrollHeight;
            //
            // },

        },
    }
</script>

<style>


</style>

<style scoped>

    .fuente {
        font-family: 'Numier', 'Roboto', sans-serif;
        font-weight: 500;
    }

    .estilo {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .imagen {
        margin-bottom: 10px;
        max-height: 200px;
        border-radius: 5px;
        position: center;
        max-width: 25%;
    }

    img {
        width: 100% !important;
    }

    .responsive {
        width: 100%;
        height: auto;
    }

    .time {
        font-size: 16px;
        color: #777;
        line-height: 17px;
    }


    h2 {
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        font-size: 2.5em;
        margin: 0 0 0.5em 0;
        line-height: 1.3;
        color: #1E22AA;
    }

    .card {
        padding: 20px;
    }

    .cont-movil {
        height: 1300px;
    }


    @media only screen and (max-width: 700px) {
        .cont-movil {
            height: 100px;
        }
    }

    .fondo-color {
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: #162229;
    }


    /*.responsiveContent {*/
    /*    position: relative;*/
    /*    height: 0;*/
    /*    resize: both;*/
    /*    overflow: hidden;*/
    /*    padding-bottom: 100%;*/
    /*    margin-bottom: 20px;*/
    /*}*/
    /*.responsiveContent iframe {*/
    /*    position: absolute;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*}*/


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Recursos/RecursosClientes.vue